/* Review slider — the only script on this page.
   The rail is a native scroll container, so the arrows do nothing the browser
   cannot already do; they scroll it by exactly one card and grey themselves
   out at the ends. No library, no autoplay, no dots: five reviews do not need
   a state machine, and autoplay on a testimonial rail steals the read. */
(function () {
  var track = document.querySelector('.reviews .track');
  if (!track) return;
  var prev = document.querySelector('.sarrow.prev');
  var next = document.querySelector('.sarrow.next');
  if (!prev || !next) return;

  function step() {
    var card = track.querySelector('.card');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function sync() {
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
  }
  /* ⚠️ THE FALLBACK IS NOT OPTIONAL. behavior:'smooth' is a silent no-op in
     some engines and under prefers-reduced-motion — measured here: the rail
     scrolled 354px with an instant scrollBy and 0px with the smooth one, so
     the arrows looked dead. If nothing has moved a frame later, jump. */
  function go(dir) {
    var from = track.scrollLeft;
    var to = from + dir * step();
    track.scrollTo({ left: to, behavior: 'smooth' });
    /* plain timeout, NOT requestAnimationFrame: rAF never fires while the tab
       is in the background, which would leave the arrows dead there. */
    setTimeout(function () {
      if (Math.abs(track.scrollLeft - from) < 1) track.scrollLeft = to;
      sync();
    }, 90);
  }
  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();